
export const isSignedIn = (state) => state.loggedIn

export const fullname = (state) => `${state.user.user.first_name || ''} ${state.user.user.last_name || ''}`
export const staffName = (state) => state.user.user.staff_name || state.user.user.email || ''
export const userPhoto = (state) => state.user.user.photo
